import { SharePoolScope } from './types';

export const sharedMembershipKeys = {
    all: ['sharedMembership'] as const,
    poolByMembership: (membershipId: string) =>
        [...sharedMembershipKeys.all, 'poolByMembership', membershipId] as const,
    poolByMemberTicket: (memberTicketId: string) =>
        [...sharedMembershipKeys.all, 'poolByMemberTicket', memberTicketId] as const,
    /** PT/그룹 어느 쪽이든 같은 화면 단위로 캐시를 무효화하기 위한 진입점. */
    poolByScope: (scope: SharePoolScope) =>
        scope.sourceType === 'MEMBERSHIP'
            ? sharedMembershipKeys.poolByMembership(scope.membershipId)
            : sharedMembershipKeys.poolByMemberTicket(scope.memberTicketId),
    /**
     * 종료 전 "무엇이 취소되는가" 프리뷰. **풀 단위로 캐시한다.**
     * 확인 목록이 낡으면 서버가 SHARE_CLOSE_PLAN_CHANGED 로 거절하므로,
     * 종료 모달을 열 때마다 새로 받는다(staleTime 0).
     */
    closePreview: (sharePoolId: string) =>
        [...sharedMembershipKeys.all, 'closePreview', sharePoolId] as const,
    templateProvisioning: (membershipId: string) =>
        [...sharedMembershipKeys.all, 'templateProvisioning', membershipId] as const,
    staffEntitlements: (centerId: string, coachId: string, memberId: string) =>
        [
            ...sharedMembershipKeys.all,
            'staffEntitlements',
            centerId,
            coachId,
            memberId,
        ] as const,
};
